// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__g20Qt","tabsBox":"styles_tabsBox__3tMbH","createButton":"styles_createButton__1N03_"};